import { categories, type CategoryId } from '../lib/categories';

interface Props {
  selected: string;
  onSelect: (id: CategoryId) => void;
}

/**
 * Chip pemilih kategori di beranda (menggantikan daftar platform, yang
 * sekarang tinggal di halaman Eksplor). Jumlahnya sedikit dan tetap,
 * jadi cukup dibungkus scroll horizontal untuk layar paling sempit.
 */
export function CategoryChips({ selected, onSelect }: Props) {
  return (
    <div
      role="tablist"
      aria-label="Kategori tontonan"
      className="-mx-4 overflow-x-auto px-4 [&::-webkit-scrollbar]:hidden"
    >
      <div className="flex gap-2 pb-1" style={{ scrollbarWidth: 'none' }}>
        {categories.map((c) => {
          const active = c.id === selected;
          return (
            <button
              key={c.id}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onSelect(c.id)}
              className={`flex min-h-[44px] shrink-0 items-center rounded-full px-4 text-sm font-semibold transition ${
                active
                  ? 'bg-gold-grad text-gold-ink shadow-gold'
                  : 'bg-ink-800 text-neutral-400 hover:text-neutral-200'
              }`}
            >
              {c.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
